var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game weare",class:{win: _vm.won}},[_c('h4',{class:{'hover-bg': _vm.won}},[_c('span',[_c('span',{domProps:{"textContent":_vm._s(_vm.message)}}),(!_vm.won)?_c('span',{staticClass:"blinking"},[_vm._v("_")]):_vm._e()])]),(_vm.help)?_c('GameHelp',[_vm._v(" BLAT ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }